import React, { Fragment } from "react";

const Pagination = props => {
  const { hasResults, pageInfo, searchFunction, disabled } = props;
  const {
    currentPage,
    totalPages,
  } = pageInfo;

  const onFirstPage = currentPage === 1;
  const onLastPage = (currentPage === totalPages) || (totalPages <= 1);
  const threeOrMorePages = totalPages >= 3;

  return (
    <div>
      <nav id="">
        <ul className="pagination">
          <li className="page-item">
            <span className="page-label">Page :</span>
          </li>
          {
            hasResults && <Fragment>
              { !onFirstPage &&
                  <Fragment>
                    <li className="page-item">
                      <button
                        className="page-link page-previous highlight"
                        onClick={() => searchFunction(currentPage - 1)}
                        disabled={disabled}
                        aria-label="previous page"
                      >
                        &#8249; Previous
                        { /* SINGLE LEFT-POINTING ANGLE QUOTATION MARK */ }
                      </button>
                    </li>
                    { onLastPage && threeOrMorePages &&
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => searchFunction(currentPage - 2)}
                            disabled={disabled}
                            aria-label={`page ${currentPage - 2}`}
                          >
                            {currentPage - 2}
                          </button>
                        </li>
                    }

                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => searchFunction(currentPage - 1)}
                        disabled={disabled}
                        aria-label={`page ${currentPage - 1}`}
                      >
                        {currentPage - 1}
                      </button>
                    </li>
                  </Fragment>
              }
              <li className="page-item active">
                <span className="page-link">
                  {currentPage}
                </span>
              </li>

              { !onLastPage &&
                  <Fragment>
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => searchFunction(currentPage + 1)}
                        disabled={disabled}
                        aria-label={`page ${currentPage + 1}`}
                      >
                        {currentPage + 1}
                      </button>
                    </li>

                    { onFirstPage && threeOrMorePages &&
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => searchFunction(currentPage + 2)}
                            disabled={disabled}
                            aria-label={`page ${currentPage + 2}`}
                          >
                            {currentPage + 2}
                          </button>
                        </li>
                    }

                    <li className="page-item">
                      <button
                        className="page-link page-next highlight"
                        onClick={() => searchFunction(currentPage + 1)}
                        disabled={disabled}
                        aria-label="next page"
                      >
                        Next &#8250;
                        { /* SINGLE RIGHT-POINTING ANGLE QUOTATION MARK */ }
                      </button>
                    </li>
                  </Fragment>
              }
            </Fragment>
          }
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
